const applyOffsetAndLimit = (
	urlParams: URLSearchParams,
	offset: number,
	limit: number
) => {
	urlParams.append('offset', String(offset))
	urlParams.append('limit', String(limit))
}

const applyFilters = (
	urlParams: URLSearchParams,
	filters?: Record<string, string>
) => {
	if (filters) {
		Object.entries(filters).forEach(([key, value]) => {
			if (value) {
				urlParams.append(key, value)
			}
		})
	}
}

const applySort = (
	urlParams: URLSearchParams,
	sort?: `${string}.${'asc' | 'desc'}`
) => {
	if (sort) {
		urlParams.append('orderBy', sort)
	}
}

export {applyOffsetAndLimit, applyFilters, applySort}
